import { render, staticRenderFns } from "./business_new_day.vue?vue&type=template&id=09296776&scoped=true&"
import script from "./business_new_day.vue?vue&type=script&lang=ts&"
export * from "./business_new_day.vue?vue&type=script&lang=ts&"
import style0 from "./business_new_day.vue?vue&type=style&index=0&id=09296776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09296776",
  null
  
)

export default component.exports